import PaginationDiv from "modules/pagination/PaginationDiv";
import React from "react";
import { Col, Row, Table } from "react-bootstrap";

function ZohoTable({ data, loading, error, pagination, setPage }) {
  return (
    <div className="rounded-2 mt-4 px-3" style={{ fontSize: 13 }}>
      <Table hover responsive>
        <thead style={{ background: "#F9FAFD" }}>
          <tr className="fs-1 rounded-top">
            <th scope="col">Order Id</th>
            <th scope="col">Failure Reason</th>
            <th scope="col">Zoho Sales Order ID</th>
            <th scope="col">Zoho Invoice ID</th>
            <th scope="col">Current Status</th>
            <th scope="col">Zoho Credit Note</th>
            <th scope="col">Invoice Date</th>
          </tr>
        </thead>
        {data ? (
          data.length ? (
            <tbody>
              {data.map((record) => {
                {
                  return (
                    <tr className="hover-actions-trigger bg-white fs-1 py-3">
                      <td className="p-3">{record?.order_display_id}</td>
                      <td className="p-3">{record?.is_zoho_failure_reason}</td>
                      <td className="p-3">{record?.zoho_sales_order_id}</td>
                      <td className="p-3">
                        {record?.zoho_current_status_code}
                      </td>
                      <td className="p-3">{record?.zoho_credit_note_id}</td>
                      <td className="p-3">{record?.zoho_invoice_date}</td>
                      <td className="p-3">{record?.zoho_invoice_id}</td>
                    </tr>
                  );
                }
              })}
            </tbody>
          ) : (
            <tr className="hover-actions-trigger bg-white fs-1 py-3">
              <td scope="col"></td>
              <td scope="col"></td>
              <td scope="col"></td>
              <td scope="col" className="p-3">
                No Data Available
              </td>
              <td scope="col"></td>
              <td scope="col"></td>
              <td scope="col"></td>
            </tr>
          )
        ) : (
          <tr className="hover-actions-trigger bg-white fs-1 py-3">
            <td scope="col"></td>
            <td scope="col"></td>
            <td scope="col"></td>
            <td scope="col" className="p-3">
              No Data Available
            </td>
            <td scope="col"></td>
            <td scope="col"></td>
            <td scope="col"></td>
          </tr>
        )}
      </Table>
      {pagination && pagination.rowCount ? (
        <PaginationDiv paginationData={pagination} newPage={setPage} />
      ) : (
        <></>
      )}
    </div>
  );
}

export default ZohoTable;
